import { apiStream } from '@/services/api-interface'
import logger from '@/services/logger/logger'
import { manageStream } from '@/services/utils'
import store from '@/store'
import { ReduxAction } from '../interfaces'
import { setMessagesCount, SET_MESSAGES_COUNT } from './actions'
import { MessagesState } from './interfaces'

export const getMessagesCount = (): void => {
  const name = 'messageCount'
  apiStream({
    name,
    url: '/messages/count/stream?read=false',
  })
    .then((response) => {
      manageStream(name, response, getMessagesCount)
      response.addEventListener('count', castEventToType)
    })
    .catch((err: Error) => logger.error(err))
}

const castEventToType = (e: Event) => store.dispatch(setMessagesCount(JSON.parse((e as MessageEvent).data).result))

export default function MessagesReducer(
  state: MessagesState = {} as MessagesState,
  action: ReduxAction,
): MessagesState {
  switch (action.type) {
    case SET_MESSAGES_COUNT: {
      return {
        ...state,
        unread: action.payload,
      }
    }
    default:
      return state
  }
}
